module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "center",
    attrs: {
      "id": "chap3"
    }
  }, [_c('i', [_vm._v("The Songs We Know Best")])]), _vm._v(" "), _c('p', {
    staticClass: "poem1",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_vm._v("Just like a shadow in an empty room")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("Like a breeze that’s pointed from beyond the tomb")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("Just like a project of which no one tells—")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("Or didja really think that I was somebody else?")]), _vm._v(" "), _c('p', {
    staticClass: "poem1",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("Your clothes and pantlegs lookin’ out of shape")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("Shape of the body over which they drape")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("Body which has acted in so many scenes")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("But didja ever think of what that body means?")]), _vm._v(" "), _c('p', {
    staticClass: "poem1",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("It is an organ and a vice to some")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("A necessary evil which we all must shun")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("To others an abstraction and a piece of meat")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("But when you’re looking out you’re in the driver’s seat!")]), _vm._v(" "), _c('p', {
    staticClass: "poem1",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("No man cares little about fleshly things")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("They fill him with a silence that spreads in rings")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("We wish to know more but we are never sated")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("No wonder some folks think the flesh is overrated!")]), _vm._v(" "), _c('p', {
    staticClass: "poem1",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("The things we know now all got learned in school")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("Try to learn a new thing and you break the rule")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("Our knowledge isn’t much it’s just a small amount")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("But you feel it quick inside you when you’re down for the count")]), _vm._v(" "), _c('p', {
    staticClass: "poem1",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("You look at me and frown like I was out of place")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("I guess I never did much for the human race")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("Just hatched some schemes on paper that looked good at first")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("Sat around and watched until the bubble burst")]), _vm._v(" "), _c('p', {
    staticClass: "poem1",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("And now you’re lookin’ good all up and down the line")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("Except for one thing you still have in mind")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("It’s always there though often with a different face")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("It’s the worm inside the jumping bean that makes it race")]), _vm._v(" "), _c('p', {
    staticClass: "poem1",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("Too often when you thought you’d be showered with confetti")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("What they flung at you was a plate of hot spaghetti")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("You’ve put your fancy clothes and flashy gems in hock")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("Yet you pause before your father’s door afraid to knock")]), _vm._v(" "), _c('p', {
    staticClass: "poem1",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("Once you knew the truth it tried to set you free")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("And still you stood transfixed just like an apple tree")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("The truth it came and went and left you in the lurch")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("And now you think you see it from your lofty perch")]), _vm._v(" "), _c('p', {
    staticClass: "poem1",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("The others come and go they’re just a dime a dozen")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("You react to them no more than to a distant cousin")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("Only a few people can touch your heart")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("And they too it seems have all gotten a false start")]), _vm._v(" "), _c('p', {
    staticClass: "poem1",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("In twilight the city with its hills shines serene")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("And lets you make of it more than anything could mean")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("It’s the same city by day that seems so crude and calm")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("You’ll have to get to know it not just pump its arm")]), _vm._v(" "), _c('p', {
    staticClass: "poem1",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("Even when that bugle sounded loud and clear")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("You knew it put an end to all your fear")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("To all that lying and the senseless mistakes")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("And now you’ve got it right and you know what it takes")]), _vm._v(" "), _c('p', {
    staticClass: "poem1",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("Someday I’ll look you up when we’re both old and gray")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("And talk about those times we had so far away")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("How much it mattered then and how it matters still")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("Only things look so different when you’ve got a will")]), _vm._v(" "), _c('p', {
    staticClass: "poem1",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("It’s true that out of this misunderstanding could end")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("And men would greet each other like they’d found a friend")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("With lots of friends around there’s no one to entice")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("And don’t you think seduction isn’t very nice?")]), _vm._v(" "), _c('p', {
    staticClass: "poem1",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("It carries in this room against the painted wall")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("And hangs in folds of curtains when it’s not there at all")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("It’s woven in the flowers of the patterned spread")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("And lies and knows not what it thinks upon the bed")]), _vm._v(" "), _c('p', {
    staticClass: "poem1",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("I wish to come to know you get to know you all")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("Let your belief in me and me in you stand tall")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("Just like a project of which no one tells—")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("Or do ya still think that I’m somebody else?")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f2f67e0c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/7chap3.vue
// module id = 78
// module chunks = 0